module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fb-Gd-Hc-Id-Ja.11cf3ddf.png";